// src/components/L3Overview/L3OverviewTabs.tsx
import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function L3OverviewTabs() {
    const location = useLocation();

    // Para "activar" el botón dependiendo de la ruta
    const isBGPActive = location.pathname === "/reflector/l3overview/bgp";
    const isLogsActive = location.pathname === "/reflector/l3overview/logs";

    return (
        <div
            className="
        inline-flex
        max-w-full
        rounded-md
        border border-semantic-border-secondary
        overflow-x-auto
        mt-1
      "
        >
            {/* BGP tab */}
            <Link
                to="/reflector/l3overview/bgp"
                className={`
          px-4 py-2
          text-sm font-medium
          transition-colors
          ${isBGPActive
                        ? "bg-white text-black"
                        : "bg-semantic-bg-primary text-semantic-text-secondary"
                    }
        `}
            >
                BGP
            </Link>

            {/* Logs tab */}
            <Link
                to="/reflector/l3overview/logs"
                className={`
          px-4 py-2
          text-sm font-medium
          border-l border-semantic-border-secondary
          transition-colors
          ${isLogsActive
                        ? "bg-white text-black"
                        : "bg-semantic-bg-primary text-semantic-text-secondary"
                    }
        `}
            >
                Logs
            </Link>
        </div>
    );
}
